// extracted by mini-css-extract-plugin
module.exports = {"nnh8dk4":"nnh8dk4","npz0jd2":"npz0jd2","active":"active","sub-tab":"sub-tab"};